import { swSettings } from "app/common/services/swSettings";
import { translate } from "app/filters/i18nFilter";
import { EHooksVersions } from "app/services/SwHook";
import { allTrackers } from "app/services/track/track";
import { buttonTypes } from "app/UtilitiesAndConstants/Constants/ButtonTypes";
import { isCompareMode } from "app/UtilitiesAndConstants/UtilityFunctions/isCompareMode";
import { isNoTouch } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { getMainDomain } from "../../helpers/helpers";
import type { SwitcherItem } from "../../types";
import { ESourceType } from "../../types";

import { EPreset } from "./types";

export const getApiParams = (selectedValue: string) => {
    const isCompare = isCompareMode();
    return isCompare ? { preset: selectedValue as EPreset } : { sourceType: selectedValue as ESourceType };
};

export const getFooterButtonConfig = (params: Record<string, any>) => [
    {
        type: buttonTypes.FLAT,
        text: translate("website.analysis.search.overview.top.non.branded.keywords.footer.btn.see.all"),
        link: proNavigator.href("organicsearch_websites_v2_traffic_keywords", { ...params }),
        onClick: () => allTrackers.dispatchTrackEvent("Internal Link", "click", "Performance/Top non-branded keywords"),
        unlockHook: {
            component: "WebsiteKeywordsV2",
            hookModal: "keywordResearch",
            version: isNoTouch(swSettings) ? EHooksVersions.V6 : EHooksVersions.V5,
        },
    },
];

export const getSwitcherItems = () => {
    const primaryDomain = getMainDomain();
    const compareItems: SwitcherItem[] = [
        {
            title: "website.analysis.search.overview.top.non.branded.keywords.switcher.highly.competitive.title",
            value: EPreset.HIGHLY_COMPETITIVE,
            changeFilter: "HighlyCompetitive",
            tooltipText: translate(
                "website.analysis.search.overview.top.non.branded.keywords.switcher.highly.competitive.tooltip",
                { primaryDomain },
            ),
        },
        {
            title: "website.analysis.search.overview.top.non.branded.keywords.switcher.opportunities.title",
            value: EPreset.OPPORTUNITIES,
            changeFilter: "Opportunities",
            tooltipText: translate(
                "website.analysis.search.overview.top.non.branded.keywords.switcher.opportunities.tooltip",
                { primaryDomain },
            ),
        },
        {
            title: "website.analysis.search.overview.top.non.branded.keywords.switcher.wins.title",
            value: EPreset.WINS,
            changeFilter: "Wins",
            tooltipText: translate("website.analysis.search.overview.top.non.branded.keywords.switcher.wins.tooltip", {
                primaryDomain,
            }),
        },
    ];
    const singleItems: SwitcherItem[] = [
        { title: "website.analysis.search.overview.all", value: ESourceType.ALL, changeFilter: "All" },
        { title: "website.analysis.search.overview.organic", value: ESourceType.ORGANIC, changeFilter: "Organic" },
        { title: "website.analysis.search.overview.paid", value: ESourceType.PAID, changeFilter: "Paid" },
    ];

    return isCompareMode() ? compareItems : singleItems;
};
